import { API_URL } from "@/config/constants";
import { buildUrl } from "@/utils/buildUrl";
import axios from "axios";
import { IFilter, Page } from "../api.types";
import { IDocumentSectionType } from "./document-section-types.types";

const API = `${API_URL}/document-section-types`;

export const getDocumentSectionTypes = async (
    page: number = 1,
    size: number = 50,
    filter?: IFilter,
    search?: string | null
) => {
    const url = buildUrl(API, { page, size, search, ...filter });
    const result = await axios.get<Page<IDocumentSectionType>>(url);
    return result.data;
};

export const updateDocumentSectionType = async (
    id: number,
    data: Partial<IDocumentSectionType>
) => {
    const url = `${API}/${id}`;
    const result = await axios.put<IDocumentSectionType>(url, data);
    return result.data;
};
